module.exports = __webpack_public_path__ + "static/design-museum@2x-e53ef5703c8c78a76735c259ea7e4b17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/customer-stories/design-museum@2x.jpg
// module id = 868
// module chunks = 33019919093843 122353984331245